var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 264,
    viewBox: "0 0 244 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.701 169.918V93.7735C243.701 73.956 233.132 55.656 215.97 45.7562L150.014 7.6748C132.853 -2.22493 111.716 -2.22493 94.5723 7.6748L28.6344 45.7562C11.4724 55.656 0.904297 73.956 0.904297 93.7735V169.918C0.904297 189.736 11.4724 208.036 28.6344 217.936L94.5904 256.017C111.752 265.917 132.889 265.917 150.033 256.017L215.989 217.936C233.132 208.036 243.701 189.736 243.701 169.918Z",
    fill: "#062644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorBlue);
export default __webpack_public_path__ + "static/media/vectorBlue.1d9c9ad07c8caae4b3643ec4356c8545.svg";
export { ForwardRef as ReactComponent };